import React, {useCallback, useEffect, useState} from 'react';
import { Button, FormGroup, Loading, Radio, Icon, Divider, Toast } from "spectre-react/dist/cjs";
import { useFetch } from '../../../hooks';
import ErrorToast from "../../shared/ErrorToast";
import {Link, useLocation} from "react-router-dom";
import {editSpecialDocPath, SIGN_OUT_PATH} from "../../../paths";


const WAGES_BONUS_PARAMS_DOC_NAME = "special:wagesBonusParams";
const WAGES_BONUS_PARAMS_EDIT_PATH = editSpecialDocPath(WAGES_BONUS_PARAMS_DOC_NAME);


const ManualBonusBlock = ({engineerId, selectedRangeISO, onSubmit, currentBonus}) => {
    const location = useLocation();

    const fetchUrl = '/api/wages/manualBonus/availableAmounts';
    const submitUrl = '/api/wages/manualBonus';

    const [fetchState, fetchActions] = useFetch(fetchUrl, { now: true });
    const [submitState, submitActions] = useFetch(submitUrl);

    const [formOpened, setFormOpened] = useState(false);
    const openForm = useCallback(() => setFormOpened(true), []);
    const closeForm = useCallback(() => setFormOpened(false), []);

    const setBonus = useCallback(({affectedEngineerId, affectedDates, amount}) => {
        try {
            const data = {affectedEngineerId, affectedDates, amount};
            submitActions.doFetch({method: 'post', data});
        } catch (error) {
            submitActions.setError(error);
        }
    }, []);

    useEffect(() => {
        if (submitState.response) {
            closeForm();

            if (onSubmit)
                onSubmit(submitState.response);
        }
    }, [submitState.response, onSubmit, closeForm]);


    const handleSubmit = (ev) => {
        ev.preventDefault();
        const amount = ev.target.elements.manualBonusPayAmount.value;
        setBonus({affectedEngineerId: engineerId, affectedDates: selectedRangeISO, amount: amount});
    };

    const removeBonus = () => {
        setBonus({affectedEngineerId: engineerId, affectedDates: selectedRangeISO, amount: 0});
    };

    // -----

    if (fetchState.error)
        return (
            <FormGroup>
                <Divider className="my-4" />
                <Toast>{fetchState.errorReason}</Toast>
            </FormGroup>
        )

    if (!fetchState.response)
        return (
            <FormGroup>
                <Divider className="my-4" />
                <Loading large />
            </FormGroup>
        );

    const {availableAmounts, canChangeAmounts} = fetchState.response;

    return (
        <form onSubmit={handleSubmit}>
            <Divider className="my-4" />

            {currentBonus > 0 && (
                <FormGroup>
                    <div>Текущий бонус: {currentBonus} ₽</div>
                </FormGroup>
            )}

            {currentBonus === 0 && !formOpened && (
                <FormGroup className="status-group">
                    <span>₽</span>
                    <Button onClick={openForm} block>Добавить бонус</Button>
                </FormGroup>
            )}

            {currentBonus > 0 && !formOpened && (
                <FormGroup className="d-flex">
                    <Button onClick={openForm} primary className="flex-1 mr-2">Изменить бонус</Button>
                    <Button onClick={removeBonus} className="flex-1">Убрать бонус</Button>
                </FormGroup>
            )}

            {formOpened && !currentBonus && (
                <FormGroup>
                    <div className="h5">Добавить бонус:</div>
                </FormGroup>
            )}

            {formOpened && (
                <>
                    <FormGroup>
                        {availableAmounts.map(amount => (
                            <Radio key={amount} large name="manualBonusPayAmount" value={amount} defaultChecked={amount === currentBonus}>
                                {amount} ₽
                            </Radio>
                        ))}
                    </FormGroup>
                    {submitState.error && (
                        <FormGroup>
                            <ErrorToast className="mt-2 mb-2" onButtonClick={submitActions.clearError}>
                                {submitState.errorReason}
                            </ErrorToast>
                        </FormGroup>
                    )}
                    {canChangeAmounts && (
                        <Link to={{pathname: WAGES_BONUS_PARAMS_EDIT_PATH, state: { from: location }}}>Изменить значения для выбора</Link>
                    )}
                    <FormGroup className="mt-3 d-flex">
                        <Button type="submit" primary loading={submitState.isLoading} className="mr-2 flex-1">Подтвердить</Button>
                        <Button onClick={closeForm} className="flex-1">Закрыть</Button>
                    </FormGroup>
                </>
            )}
        </form>
    );
};


export default ManualBonusBlock;